import { Banner } from '@/components/Banner/Banner';
import { RichText } from '@/components/RichText/RichText';
import { languageStrings } from '@/l18n/de';
import { getSmartPlusPurUrl } from '@/lib/banner';

const BannerSmartPlusPur = () => {
	const ctaUrl = getSmartPlusPurUrl();
	const { heading, explanation } = languageStrings.smartPlusPurHint;

	return (
		<Banner className="banner-warning">
			<div className="banner--active-hint">
				<strong>{heading}</strong>
				<span>
					<RichText
						components={{
							link: <a href={ctaUrl} rel="noreferrer" />
						}}
						message={explanation}
					/>
				</span>
			</div>
		</Banner>
	);
};

export { BannerSmartPlusPur };
